"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionBaseDefault = void 0;
exports.collectionBaseDefault = {
    invites: 'invites',
    workspaces: 'workspaces',
    userMetas: 'userMetas',
    users: 'users',
    uploadedFiles: 'uploadedFiles',
    feedbacks: 'feedbacks',
    workspaceUsers: 'workspaceUsers',
    workspaceStats: 'stats',
    aiSuggestions: 'aiSuggestions',
};
